<div class="row d-flex justify-content-center">
	<div class="card col-6">
		<div class="card-body">
			<h5 class="card-title text-center mb-5 theme-main-color">
				Récupérer mon mot de passe
			</h5>

			<div class="input-group mb-3">
				<div class="input-group-prepend">
					<span class="input-group-text" id="recoveryEmail">Mon email: </span>
				</div>
				<input
					type="text"
					class="form-control"
					pattern="([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|'([]!#-[^-~ \t]|(\\[\t -~]))+')@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+"
					aria-label="recoveryEmail"
					aria-describedby="recoveryEmail"
					[(ngModel)]="recoveryEmail"
					name="recoveryEmail"
					#recoveryEmailModel="ngModel"
				/>
			</div>
			<div
				[hidden]="recoveryEmailModel.valid || recoveryEmailModel.pristine"
				class="alert alert-danger"
				profile="alert"
			>
				L'email est invalide.
			</div>

			<div
				class="alert alert-success alert-dismissible fade show mb-4"
				profile="alert"
				*ngIf="successfullySent"
			>
				<button
					type="button"
					class="btn"
					data-dismiss="alert"
					aria-label="Close"
					(click)="closeAlerts()"
				>
					<span aria-hidden="true" class="bi bi-x-lg"></span>
				</button>
				Un email vient de vous être envoyé ! L'arrivée de l'email peut prendre
				quelques minutes, veuillez patienter jusqu'à son arrivée.
			</div>
			<div
				class="alert alert-danger alert-dismissible fade show"
				profile="alert"
				*ngIf="unsuccessfullySent"
			>
				<button
					type="button"
					class="btn"
					data-dismiss="alert"
					aria-label="Close"
					(click)="closeAlerts()"
				>
					<span aria-hidden="true" class="bi bi-x-lg"></span>
				</button>
				Mail non envoyé : une erreur est survenue. Si l'erreur persiste,
				veuillez prendre contact avec un administrateur.
			</div>

			<button class="btn theme-red-button float-start mt-3" routerLink="/login">
				Annuler
			</button>
			<button
				class="btn theme-main-color-full-button float-end mt-3"
				(click)="sendPasswordRecovery()"
				[disabled]="
					recoveryEmail === '' || sendButtonClicked || !recoveryEmailModel.valid
				"
			>
				Envoyer le mail de récupération
			</button>
		</div>
	</div>
</div>
